// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1KlBC","content":"LoadingAlert_content__VD9X1"};